import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AddStorageHubModalComponent } from './add-storage-hub-modal.component';
import { AdjustInventoryModalComponent } from './adjust-inventory-modal.component';
import { TransferModalComponent } from './transfer-modal.component';
import { ConfirmTransfersDialogComponent } from '../confirm-transfers-dialog/confirm-transfers-dialog.component';
import { HelpModalComponent } from './help-modal.component';

@NgModule({
  declarations: [
    AddStorageHubModalComponent,
    AdjustInventoryModalComponent,
    TransferModalComponent,
    ConfirmTransfersDialogComponent,
    HelpModalComponent
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [
    AddStorageHubModalComponent,
    AdjustInventoryModalComponent,
    TransferModalComponent,
    ConfirmTransfersDialogComponent,
    HelpModalComponent
  ]
})
export class SharedModalsModule {}
